module.exports = __webpack_public_path__ + "static/media/contact-240620.3460f297.jpg";